// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__aX9b8","bodyModal":"styles_bodyModal__BLkQH","footerModal":"styles_footerModal__5fQ3W","addCustomerModal":"styles_addCustomerModal__HBzg3"};